<template lang="pug">
svg(
    :width="width"
    :height="height"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
)
    path(
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.1124 13.1318C22.164 12.1684 22.8208 10.7997 22.8208 9.28125C22.8208 6.3645 20.3972 4 17.4074 4C14.4177 4 11.994 6.3645 11.994 9.28125C11.994 10.7995 12.6506 12.168 13.702 13.1314L9.47861 19.8354C8.84221 19.579 8.14475 19.4375 7.41341 19.4375C4.42367 19.4375 2 21.802 2 24.7188C2 27.6355 4.42367 30 7.41341 30C9.89815 30 11.9919 28.3668 12.6283 26.1408L22.1865 26.1408C22.8229 28.3668 24.9167 30 27.4014 30C30.3911 30 32.8148 27.6355 32.8148 24.7188C32.8148 21.802 30.3911 19.4375 27.4014 19.4375C26.6699 19.4375 25.9722 19.5791 25.3357 19.8356L21.1124 13.1318ZM20.3556 9.28125C20.3556 10.8698 19.0357 12.1575 17.4074 12.1575C15.7791 12.1575 14.4592 10.8698 14.4592 9.28125C14.4592 7.69274 15.7791 6.405 17.4074 6.405C19.0357 6.405 20.3556 7.69274 20.3556 9.28125ZM18.978 14.3368C18.4809 14.4836 17.9536 14.5625 17.4074 14.5625C16.861 14.5625 16.3335 14.4835 15.8363 14.3366L11.487 21.2405C12.1109 21.9353 12.551 22.7911 12.7332 23.7358L22.0816 23.7358C22.2638 22.7913 22.7037 21.9357 23.3274 21.2409L18.978 14.3368ZM30.3496 24.7188C30.3496 26.3073 29.0297 27.595 27.4014 27.595C25.7731 27.595 24.4532 26.3073 24.4532 24.7188C24.4532 23.1302 25.7731 21.8425 27.4014 21.8425C29.0297 21.8425 30.3496 23.1302 30.3496 24.7188ZM7.41341 27.595C9.04167 27.595 10.3616 26.3073 10.3616 24.7188C10.3616 23.1302 9.04167 21.8425 7.41341 21.8425C5.78515 21.8425 4.46519 23.1302 4.46519 24.7188C4.46519 26.3073 5.78515 27.595 7.41341 27.595Z"
        :fill="iconColor"
    )
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  name: "UnionIcon",
  props: {
    color: String,
    width: { type: Number, default: 26 },
    height: { type: Number, default: 26 },
  },
  computed: {
    iconColor(): string | undefined {
      switch (this.color) {
        case "primary":
          return this.$vuetify.theme.themes.light.primary?.toString()
        case "textColor":
          return this.$vuetify.theme.themes.light.textColor?.toString()
        default:
          return this.color
      }
    },
  },
})
</script>
